import { DisplayText } from "@rentiohq/web-shared/dist/components";
import { Icon } from "@rentiohq/web-shared/dist/components";
import styled from "@rentiohq/web-theme";

export const Header = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TaskRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const TaskTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral90};
`;

export const TaskMeta = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral90};
  margin-top: 2px;
`;

export const TaskDate = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral60};
  margin-top: 2px;
`;

export const AddTaskBtn = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  justify-content: center;
  border-radius: 4px;
  border: 0.6px solid ${({ theme }) => theme.colors.green80};
  color: ${({ theme }) => theme.colors.green80};
  cursor: pointer;
  padding-bottom: 2px;
  align-items: center;
`;

export const Title = styled(DisplayText)`
  margin-bottom: 0 !important;
`;

export const TaskIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.black};
`;
